import "./index.scss";

export const SellHeader = () => (
  <div className="sell-header">
    <h1>Sell gift cards fast.</h1>
    <p>Earn cash for unwanted cards and store credits.</p>
  </div>
);
